import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=2eac21e2&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=2eac21e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eac21e2",
  null
  
)

export default component.exports